// src/assets/data/imageMap.js

// Imports for known product images
import AQ01BLUE from "../images/AQ 01 BLUE.webp";
import AQ01WHITE from "../images/AQ 01 WHITE.webp";
import AQ02BLUE from "../images/AQ 02 BLUE.webp";
import AQ02WHITE from "../images/AQ 02 WHITE.webp";
import AQ03BLUE from "../images/AQ 03 BLUE.webp";
import AQ03WHITE from "../images/AQ 03 WHITE.webp";
import AQ04BLUE from "../images/AQ 04 BLUE.webp";
import AQ04WHITE from "../images/AQ 04 WHITE.webp";
import AQ05BLUE from "../images/AQ 05 BLUE.webp";
import AQ05WHITE from "../images/AQ 05 WHITE.webp";
import AQ06BLUE from "../images/AQ 06 BLUE.webp";
import AQ06WHITE from "../images/AQ 06 WHITE.webp";
import AQ07BLUE from "../images/AQ 07 BLUE.webp";
import AQ07WHITE from "../images/AQ 07 WHITE.webp";
import AQ08BLUE from "../images/AQ 08 BLUE.webp";
import AQ08WHITE from "../images/AQ 08 WHITE.webp";
import AQ09BLUE from "../images/AQ 09 BLUE.webp";
import AQ09WHITE from "../images/AQ 09 WHITE.webp";
import AQ10BLUE from "../images/AQ 10 BLUE.webp";
import AQ10WHITE from "../images/AQ 10 WHITE.webp";
import AQ11BLUE from "../images/AQ 11 BLUE.webp";
import AQ11WHITE from "../images/AQ 11 WHITE.webp";
import AQ12BLUE from "../images/AQ 12 BLUE.webp";
import AQ12WHITE from "../images/AQ 12 WHITE.webp";
import AQ13BLUE from "../images/AQ 13 BLUE.webp";
import AQ13WHITE from "../images/AQ 13 WHITE.webp";
import AQ14BLUE from "../images/AQ 14 BLUE.webp";
import AQ14WHITE from "../images/AQ 14 WHITE.webp";
import AQ15BLUE from "../images/AQ 15 BLUE.webp";
import AQ15WHITE from "../images/AQ 15 WHITE.webp";
import ECO01 from "../images/ECO 01.webp";
import ECO02 from "../images/ECO 02.webp";
import ET01 from "../images/ET 01.webp";
import ET02 from "../images/ET 02.webp";
import ET03 from "../images/ET 03.webp";
import ET04 from "../images/ET 04.webp";
import ET05 from "../images/ET 05.webp";
import ET06 from "../images/ET 06.webp";
import ET07 from "../images/ET 07.webp";
import ET08 from "../images/ET 08.webp";
import ET09 from "../images/ET 09.webp";
import ET10 from "../images/ET 10.webp";
import ET11 from "../images/ET 11.webp";
import ET12 from "../images/ET 12.webp";
import ET13 from "../images/ET 13.webp";
import ET14 from "../images/ET 14.webp";
//import ET15 from "../images/ET 15.webp";
import HE01 from "../images/HE 01.webp";
import HE02 from "../images/HE 02.webp";
import HE03 from "../images/HE 03.webp";
import HE04 from "../images/HE 04.webp";
import HE06 from "../images/HE 06.webp";
import HE07 from "../images/HE 07.webp";
import HE08 from "../images/HE 08.webp";
import NV01 from "../images/NV 01.webp";
import NV02 from "../images/NV 02.webp";
import NV03 from "../images/NV 03.webp";
import NV04 from "../images/NV 04.webp";
import OAK01DARK from "../images/OAK 01 DARK.webp";
import OAK01LIGHT from "../images/OAK 01 LIGHT.webp";
import OAK02DARK from "../images/OAK 02 DARK.webp";
import OAK02LIGHT from "../images/OAK 02 LIGHT.webp";
import OAK03DARK from "../images/OAK 03 DARK.webp";
import OAK03LIGHT from "../images/OAK 03 LIGHT.webp";
import OAK04DARK from "../images/OAK 04 DARK.webp";
import OAK04LIGHT from "../images/OAK 04 LIGHT.webp";
import OAK05DARK from "../images/OAK 05 DARK.webp";
import OAK05LIGHT from "../images/OAK 05 LIGHT.webp";
import OAK06DARK from "../images/OAK 06 DARK.webp";
import OAK06LIGHT from "../images/OAK 06 LIGHT.webp";
import OAK07DARK from "../images/OAK 07 DARK.webp";
import OAK07LIGHT from "../images/OAK 07 LIGHT.webp";
import OAK08DARK from "../images/OAK 08 DARK.webp";
import OAK08LIGHT from "../images/OAK 08 LIGHT.webp";
import OAK09DARK from "../images/OAK 09 DARK.webp";
import OAK09LIGHT from "../images/OAK 09 LIGHT.webp";
import OAK10DARK from "../images/OAK 10 DARK.webp";
import OAK10LIGHT from "../images/OAK 10 LIGHT.webp";
import OAK11DARK from "../images/OAK 11 DARK.webp";
import OAK11LIGHT from "../images/OAK 11 LIGHT.webp";
import OAK12DARK from "../images/OAK 12 DARK.webp";
import OAK12LIGHT from "../images/OAK 12 LIGHT.webp";
import OAK13DARK from "../images/OAK 13 DARK.webp";
import OAK13LIGHT from "../images/OAK 13 LIGHT.webp";
import OAK14DARK from "../images/OAK 14 DARK.webp";
import OAK14LIGHT from "../images/OAK 14 LIGHT.webp";
import OAK15DARK from "../images/OAK 15 DARK.webp";
import OAK15LIGHT from "../images/OAK 15 LIGHT.webp";
import ON01GOLD from "../images/ON 01 GOLD.webp";
import ON01GREY from "../images/ON 01 GREY.webp";
import ON02GOLD from "../images/ON 02 GOLD.webp";
import ON02GREY from "../images/ON 02 GREY.webp";
import ON03GOLD from "../images/ON 03 GOLD.webp";
import ON03GREY from "../images/ON 03 GREY.webp";
import ON04GOLD from "../images/ON 04 GOLD.webp";
import ON04GREY from "../images/ON 04 GREY.webp";
import ON05GOLD from "../images/ON 05 GOLD.webp";
import ON05GREY from "../images/ON 05 GREY.webp";
import ON06GOLD from "../images/ON 06 GOLD.webp";
import ON06GREY from "../images/ON 06 GREY.webp";
import ON07GOLD from "../images/ON 07 GOLD.webp";
import ON07GREY from "../images/ON 07 GREY.webp";
import ON08GOLD from "../images/ON 08 GOLD.webp";
import ON08GREY from "../images/ON 08 GREY.webp";
import ON09GOLD from "../images/ON 09 GOLD.webp";
import ON09GREY from "../images/ON 09 GREY.webp";
import ON10GOLD from "../images/ON 10 GOLD.webp";
import ON10GREY from "../images/ON 10 GREY.webp";
import ON11GOLD from "../images/ON 11 GOLD.webp";
import ON11GREY from "../images/ON 11 GREY.webp";
import ON12GOLD from "../images/ON 12 GOLD.webp";
import ON12GREY from "../images/ON 12 GREY.webp";
import ON13GOLD from "../images/ON 13 GOLD.webp";
import ON13GREY from "../images/ON 13 GREY.webp";
import ON14GOLD from "../images/ON 14 GOLD.webp";
import ON14GREY from "../images/ON 14 GREY.webp";
import ON15GOLD from "../images/ON 15 GOLD.webp";
import ON15GREY from "../images/ON 15 GREY.webp";
import PA01 from "../images/PA 01.webp";
import PA02 from "../images/PA 02.webp";
import PA03 from "../images/PA 03.webp";
import PA04 from "../images/PA 04.webp";
import PA05 from "../images/PA 05.webp";
import PA06 from "../images/PA 06.webp";
import PA07 from "../images/PA 07.webp";
import PA08 from "../images/PA 08.webp";
import PA09 from "../images/PA 09.webp";
import PA10 from "../images/PA 10.webp";
import PA11 from "../images/PA 11.webp";
import PA12 from "../images/PA 12.webp";
import PA13 from "../images/PA 13.webp";
import PA14 from "../images/PA 14.webp";
import PA15WHITE from "../images/PA 15 WHITE.webp";
import PA15BLUE from "../images/PA 15 BLUE.webp";
import PA15GREY from "../images/PA 15 GREY.webp";
import RY01BLUE from "../images/RY 01 BLUE.webp";
import RY01WHITE from "../images/RY 01 WHITE.webp";
import RY02BLUE from "../images/RY 02 BLUE.webp";
import RY02WHITE from "../images/RY 02 WHITE.webp";
import RY03BLUE from "../images/RY 03 BLUE.webp";
import RY03WHITE from "../images/RY 03 WHITE.webp";
import RY04BLUE from "../images/RY 04 BLUE.webp";
import RY04WHITE from "../images/RY 04 WHITE.webp";
import SD01 from "../images/SD 01.webp";
import SD02 from "../images/SD 02.webp";
import SD03 from "../images/SD 03.webp";
import SD04 from "../images/SD 04.webp";
import SD05 from "../images/SD 05.webp";
import SD06 from "../images/SD 06.webp";
import SD07 from "../images/SD 07.webp";
import SD08 from "../images/SD 08.webp";
import SD09 from "../images/SD 09.webp";
import SD10 from "../images/SD 10.webp";
import SD11 from "../images/SD 11.webp";
import SD12 from "../images/SD 12.webp";
import SD13 from "../images/SD 13.webp";
import SD14 from "../images/SD 14.webp";
import SD15 from "../images/SD 15.webp";



// optional fallback

// Map image file names (must match the "Image" field in JSON exactly)
const imageMap = {
"AQ 01 BLUE.webp" : AQ01BLUE,
"AQ 01 WHITE.webp" : AQ01WHITE,
"AQ 02 BLUE.webp" : AQ02BLUE,
"AQ 02 WHITE.webp" : AQ02WHITE,
"AQ 03 BLUE.webp" : AQ03BLUE,
"AQ 03 WHITE.webp" : AQ03WHITE,
"AQ 04 BLUE.webp" : AQ04BLUE,
"AQ 04 WHITE.webp" : AQ04WHITE,
"AQ 05 BLUE.webp" : AQ05BLUE,
"AQ 05 WHITE.webp" : AQ05WHITE,
"AQ 06 BLUE.webp" : AQ06BLUE,
"AQ 06 WHITE.webp" : AQ06WHITE,
"AQ 07 BLUE.webp" : AQ07BLUE,
"AQ 07 WHITE.webp" : AQ07WHITE,
"AQ 08 BLUE.webp" : AQ08BLUE,
"AQ 08 WHITE.webp" : AQ08WHITE,
"AQ 09 BLUE.webp" : AQ09BLUE,
"AQ 09 WHITE.webp" : AQ09WHITE,
"AQ 10 BLUE.webp" : AQ10BLUE,
"AQ 10 WHITE.webp" : AQ10WHITE,
"AQ 11 BLUE.webp" : AQ11BLUE,
"AQ 11 WHITE.webp" : AQ11WHITE,
"AQ 12 BLUE.webp" : AQ12BLUE,
"AQ 12 WHITE.webp" : AQ12WHITE,
"AQ 13 BLUE.webp" : AQ13BLUE,
"AQ 13 WHITE.webp" : AQ13WHITE,
"AQ 14 BLUE.webp" : AQ14BLUE,
"AQ 14 WHITE.webp" : AQ14WHITE,
"AQ 15 BLUE.webp" : AQ15BLUE,
"AQ 15 WHITE.webp" : AQ15WHITE,
"ECO 01.webp" : ECO01,
"ECO 02.webp" : ECO02,
"ET 01.webp" : ET01,
"ET 02.webp" : ET02,
"ET 03.webp" : ET03,
"ET 04.webp" : ET04,
"ET 05.webp" : ET05,
"ET 06.webp" : ET06,
"ET 07.webp" : ET07,
"ET 08.webp" : ET08,
"ET 09.webp" : ET09,
"ET 10.webp" : ET10,
"ET 11.webp" : ET11,
"ET 12.webp" : ET12,
"ET 13.webp" : ET13,
"ET 14.webp" : ET14,
//"ET 15.webp" : ET15,
"HE 01.webp" : HE01,
"HE 02.webp" : HE02,
"HE 03.webp" : HE03,
"HE 04.webp" : HE04,
"HE 06.webp" : HE06,
"HE 07.webp" : HE07,
"HE 08.webp" : HE08,
"NV 01.webp" : NV01,
"NV 02.webp" : NV02,
"NV 03.webp" : NV03,
"NV 04.webp" : NV04,
"OAK 01 DARK.webp" : OAK01DARK,
"OAK 01 LIGHT.webp" : OAK01LIGHT,
"OAK 02 DARK.webp" : OAK02DARK,
"OAK 02 LIGHT.webp" : OAK02LIGHT,
"OAK 03 DARK.webp" : OAK03DARK,
"OAK 03 LIGHT.webp" : OAK03LIGHT,
"OAK 04 DARK.webp" : OAK04DARK,
"OAK 04 LIGHT.webp" : OAK04LIGHT,
"OAK 05 DARK.webp" : OAK05DARK,
"OAK 05 LIGHT.webp" : OAK05LIGHT,
"OAK 06 DARK.webp" : OAK06DARK,
"OAK 06 LIGHT.webp" : OAK06LIGHT,
"OAK 07 DARK.webp" : OAK07DARK,
"OAK 07 LIGHT.webp" : OAK07LIGHT,
"OAK 08 DARK.webp" : OAK08DARK,
"OAK 08 LIGHT.webp" : OAK08LIGHT,
"OAK 09 DARK.webp" : OAK09DARK,
"OAK 09 LIGHT.webp" : OAK09LIGHT,
"OAK 10 DARK.webp" : OAK10DARK,
"OAK 10 LIGHT.webp" : OAK10LIGHT,
"OAK 11 DARK.webp" : OAK11DARK,
"OAK 11 LIGHT.webp" : OAK11LIGHT,
"OAK 12 DARK.webp" : OAK12DARK,
"OAK 12 LIGHT.webp" : OAK12LIGHT,
"OAK 13 DARK.webp" : OAK13DARK,
"OAK 13 LIGHT.webp" : OAK13LIGHT,
"OAK 14 DARK.webp" : OAK14DARK,
"OAK 14 LIGHT.webp" : OAK14LIGHT,
"OAK 15 DARK.webp" : OAK15DARK,
"OAK 15 LIGHT.webp" : OAK15LIGHT,
"ON 01 GOLD.webp" : ON01GOLD,
"ON 01 GREY.webp" : ON01GREY,
"ON 02 GOLD.webp" : ON02GOLD,
"ON 02 GREY.webp" : ON02GREY,
"ON 03 GOLD.webp" : ON03GOLD,
"ON 03 GREY.webp" : ON03GREY,
"ON 04 GOLD.webp" : ON04GOLD,
"ON 04 GREY.webp" : ON04GREY,
"ON 05 GOLD.webp" : ON05GOLD,
"ON 05 GREY.webp" : ON05GREY,
"ON 06 GOLD.webp" : ON06GOLD,
"ON 06 GREY.webp" : ON06GREY,
"ON 07 GOLD.webp" : ON07GOLD,
"ON 07 GREY.webp" : ON07GREY,
"ON 08 GOLD.webp" : ON08GOLD,
"ON 08 GREY.webp" : ON08GREY,
"ON 09 GOLD.webp" : ON09GOLD,
"ON 09 GREY.webp" : ON09GREY,
"ON 10 GOLD.webp" : ON10GOLD,
"ON 10 GREY.webp" : ON10GREY,
"ON 11 GOLD.webp" : ON11GOLD,
"ON 11 GREY.webp" : ON11GREY,
"ON 12 GOLD.webp" : ON12GOLD,
"ON 12 GREY.webp" : ON12GREY,
"ON 13 GOLD.webp" : ON13GOLD,
"ON 13 GREY.webp" : ON13GREY,
"ON 14 GOLD.webp" : ON14GOLD,
"ON 14 GREY.webp" : ON14GREY,
"ON 15 GOLD.webp" : ON15GOLD,
"ON 15 GREY.webp" : ON15GREY,
"PA 01.webp" : PA01,
"PA 02.webp" : PA02,
"PA 03.webp" : PA03,
"PA 04.webp" : PA04,
"PA 05.webp" : PA05,
"PA 06.webp" : PA06,
"PA 07.webp" : PA07,
"PA 08.webp" : PA08,
"PA 09.webp" : PA09,
"PA 10.webp" : PA10,
"PA 11.webp" : PA11,
"PA 12.webp" : PA12,
"PA 13.webp" : PA13,
"PA 14.webp" : PA14,
"PA 15 BLUE.webp" : PA15BLUE,
"PA 15 WHITE.webp" : PA15WHITE,
"PA 15 GREY.webp" : PA15BLUE,
"RY 01 BLUE.webp" : RY01BLUE,
"RY 01 WHITE.webp" : RY01WHITE,
"RY 02 BLUE.webp" : RY02BLUE,
"RY 02 WHITE.webp" : RY02WHITE,
"RY 03 BLUE.webp" : RY03BLUE,
"RY 03 WHITE.webp" : RY03WHITE,
"RY 04 BLUE.webp" : RY04BLUE,
"RY 04 WHITE.webp" : RY04WHITE,
"SD 01.webp" : SD01,
"SD 02.webp" : SD02,
"SD 03.webp" : SD03,
"SD 04.webp" : SD04,
"SD 05.webp" : SD05,
"SD 06.webp" : SD06,
"SD 07.webp" : SD07,
"SD 08.webp" : SD08,
"SD 09.webp" : SD09,
"SD 10.webp" : SD10,
"SD 11.webp" : SD11,
"SD 12.webp" : SD12,
"SD 13.webp" : SD13,
"SD 14.webp" : SD14,
"SD 15.webp" : SD15,
};

export default imageMap;
